// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2Woqh","importantInfo":"styles_importantInfo__33quq"};